import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface Faq {
    id: number;
    question: string;
    answer: string;
    expanded: boolean;
}

interface IProps {
    faq: Faq;
    onOpen: (id: number) => void;
}

export default function FaqExpandable(props: IProps) {
    const { t } = useTranslation();

    const toggle = () => {
        props.onOpen(props.faq.id);
    }

    return (
        <div className={props.faq.expanded ? 'faq-item expand' : 'faq-item'}>
            <div className='faq-question' onClick={toggle}>
                <div className='faq-question-text'>
                    {t(props.faq.question)}
                </div>
                <div className='faq-question-arrow'>
                    <i className="fas fa-chevron-down"></i>
                </div>
            </div>
            <div className='faq-answer'>
                <div className='faq-answer-text'>
                    {t(props.faq.answer)}
                </div>
            </div>
        </div>
    )
}